import { Props_SnippetLinkBox } from './LinkBox.props'
import SnippetLink from '../Shared/Link/Link'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetLinkBox = (props: Props_SnippetLinkBox) => {
    const { heading, paragraph, repeatable_entry } = props
    const headingContent = heading.content?.value;
    const paragraphText = paragraph.text?.value;
    const classHeadingVisibiity: string = heading.visibility?.value === true ? 'snippet-link-box__heading--visible' : 'snippet-link-box__heading--hidden'

    return (
        <section className="snippet-link-box">
            <div className={`snippet-link-box__container`}>
                <div className={`snippet-link-box__heading ${classHeadingVisibiity}`}>{CompileMarkdown(headingContent!)}</div>
                {paragraphText && (
                    <div className="snippet-link-box__paragraph">
                        {CompileMarkdown(paragraphText)}
                    </div>
                )}
                <div className="snippet-link-box__container-entries">
                    {repeatable_entry.map((entry, index: number) => (
                        <div key={index} className={`snippet-link-box__entry`}>
                            {entry.image?.value && (
                            <figure className="snippet-link-box__entry-container-image">
                                <img
                                    className="snippet-link-box__entry-image"
                                    loading="lazy"
                                    height="300"
                                    width="373"
                                    src={entry.image?.value}
                                    alt={entry?.alt?.value ? entry.alt.value : ''}
                                />
                            </figure>)}
                            <div className="snippet-link-box__entry-container-content">
                              {entry.heading?.value && <div className="snippet-link-box__entry-title">{CompileMarkdown(entry.heading.value)}</div>}

                                <SnippetLink
                                    linkStyles={entry.linkStyle?.value}
                                    className="snippet-link-box__entry-link"
                                    url={entry.linkHref?.value}
                                    openInNewTab={entry.linkTarget?.value}
                                >
                                    {entry.linkText?.value}
                                </SnippetLink>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetLinkBox